import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import type { ACMEResponse } from "@b2b/types/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * CustomerFeesApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/customerFeesApi/customerFeesApi.service.ts
 * (which was an intermediate AngularJS-class TS rewrite that still used `$http`).
 */
const CUSTOMER_FEES_BASE = "/v1/api/customer/fees/configs";

export interface CustomerFeeConfig {
  id?: number;
  name: string;
  type?: string;
  presentmentType: "PRECHECK" | "OPTIONAL";
  salesChannels?: { id: number }[];
  percentage: string | number;
  fixed: string | number;
  inputLabel: string;
  tooltipLabel: string;
  refundable: boolean;
  active: boolean;
}

@Injectable({ providedIn: "root" })
export class CustomerFeesApiService {
  private readonly http = inject(HttpClient);

  list(): Promise<AjsResponse<ACMEResponse<{ list: CustomerFeeConfig[] }>>> {
    return wrapAjs(
      this.http.get<ACMEResponse<{ list: CustomerFeeConfig[] }>>(
        CUSTOMER_FEES_BASE,
      ),
    );
  }

  create(
    data: CustomerFeeConfig,
  ): Promise<AjsResponse<ACMEResponse<CustomerFeeConfig>>> {
    return wrapAjs(
      this.http.post<ACMEResponse<CustomerFeeConfig>>(CUSTOMER_FEES_BASE, data),
    );
  }

  update(
    id: number,
    data: CustomerFeeConfig,
  ): Promise<AjsResponse<ACMEResponse<CustomerFeeConfig>>> {
    return wrapAjs(
      this.http.put<ACMEResponse<CustomerFeeConfig>>(
        `${CUSTOMER_FEES_BASE}/${id}`,
        data,
      ),
    );
  }
}
